import { CANCEL_FETCH_MESSAGE } from 'hb-react/shared/constants/cancelFetch';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import { HTTP_STATUS_CODE_403 } from '../constants/httpStatusCode';
import handleDisplayErrorToast from '../utils/handleDisplayErrorToast';

const getUrl = (id, config) => Routes.topics_topic_category_path(id, config);

const getConfig = (format, cancelToken, withCategorySet) => {
  const config = {
    format,
    cancelToken: cancelToken.token,
  };

  if (withCategorySet) {
    return { ...config, with_category_set: true };
  }

  return config;
};

const handleResponse = (data, withCategorySet) => {
  if (withCategorySet) {
    const { topic_category: topicCategory } = data;
    const { category_set: categorySet, description, id, name } = topicCategory;
    const {
      id: idCategorySet,
      is_default: isDefault,
      name: nameCategorySet,
    } = categorySet;

    return {
      category: {
        description,
        id,
        name,
      },
      superCategory: {
        id: idCategorySet,
        isDefault,
        name: nameCategorySet,
      },
    };
  }

  const { topic_category: category } = data;

  return { category };
};

const fetchCategory = ({
  cancelToken,
  format = 'json',
  id,
  withCategorySet = false,
}) =>
  axios
    .get(getUrl(id, getConfig(format, cancelToken, withCategorySet)))
    .then(({ data }) => handleResponse(data, withCategorySet))
    .catch((error) => {
      if (error.message === CANCEL_FETCH_MESSAGE) {
        return null;
      }

      if (error.response.status !== HTTP_STATUS_CODE_403) {
        handleDisplayErrorToast(error);
      }

      return error;
    });

export default fetchCategory;
